<template>
  <div class="query-container">
    <QueryView
      ref="queryView"
      :table-config="tableConfig"
      :town-selection="false"
      :region-selection="true"
      :province-selection="true"
      use-expansion
    >
      <template #header>
        <MultiSelect
          v-model="selectedFields"
          :options="categories"
          option-label="label"
          option-value="field"
          filter
          placeholder="Categoría"
          class="w-full md:w-16rem query__category-select"
          @update:model-value="updateSelectedFields"
        >
          <template #option="slotProps">
            <div class="flex items-center custom-item-template">
              <span class="material-icons">{{ slotProps.option.icon }}</span>
              <span class="label-multiselect">{{ slotProps.option.label }}</span>
            </div>
          </template>
        </MultiSelect>
      </template>
      <template #expansion="{ data }">
        <div
          class="query__expansion-container"
        >
          <QueryExpansionField
            field-name="Descripción"
            :field-value="data.description"
          />
        </div>
      </template>
    </QueryView>
  </div>
</template>

<script setup>
import {ref, computed} from 'vue';
import {useClipboard} from '@vueuse/core';
import QueryView from '../QueryView';
import QueryExpansionField from '@/components/query-expansion-field/QueryExpansionField';
import QueryTableConfig from '../query-table.view-config.js';
import {POI_SCHEMA, POI_FILTERS} from './query-poi-table.view-config';
import MultiSelect from 'primevue/multiselect';
import {searchPOI} from '@/api/poi/poi.api';
import {
  searchPOIHtml,
  searchPOIPdf,
  getPOIPdf,
} from '@/api/poi/poi.api.pdf.js';
// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const queryView = ref();
const {copy} = useClipboard();
const selectedFields = ref([]);
const selectedFilters = computed(() => {
  return categories.value.map((category) => ({
    field: category.field,
    icon: category.icon,
    value: selectedFields.value.includes(category.field),
  }));
});

const categories = computed(() => {
  return POI_FILTERS.map((item) => ({
    ...item,
  }));
});
//  #endregion
// #region Functions
function updateFilters() {
  queryView.value.updateAdvancedFilters(selectedFilters.value);
}
function updateSelectedFields(newFields) {
  selectedFields.value = newFields;
  updateFilters();
}
async function printPOI(data) {
  const printRecord = queryView?.value?.printRecord ?? null;
  if (!!printRecord) {
    await printRecord(data.id, 'Lugar de interés - ' + data.name, getPOIPdf);
  }
}
async function htmlPOIQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Lugares de interés', searchPOIHtml, 'html');
  }
}
async function printPOIQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Lugares de interés', searchPOIPdf);
  }
}
async function goPOI({coordinates, name, visible}) {
  const goCoordinates = queryView?.value?.goCoordinates;
  const zoom = 13;
  if (!!goCoordinates) {
    goCoordinates({coordinates, name, visible, zoom});
  }
}
function poiToText({name, province, region, category, description}) {
  const res = `
    Nombre: ${name}
    Provincia: ${province}
    Comunidad Autónoma: ${region}
    Categoría: ${category}
    Descripción: ${description}
    `;
  return res;
}
// #endregion
// functions previously defined
const tableConfig = new QueryTableConfig({
  title: '',
  api: searchPOI,
  recordToText: poiToText,
  copyClipboard: copy,
  htmlQuery: htmlPOIQuery,
  printQuery: printPOIQuery,
  printRecord: printPOI,
  centerMap: goPOI,
  schema: POI_SCHEMA,
  filterFields: [],
});
// #region Effects, Hooks
// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
.query-container {
  & :deep(.p-chip) {
    display: none;
  }
}
.label-multiselect {
  padding-top: 3px;
  padding-left: 4px;
}
</style>
